//import blocks
import {headerBlock} from "./headerBlock";
import {footerBlock} from './footerBlock';
import {hero_block} from './hero_block';
import {mission_block} from './mission_block';
import {vision_block} from './vision_block';
import {our_locations_block} from './our_locations_block';
import {about_us_block} from './about_us_block';
import {contact_us_block} from './contact_us_block';
import {send_message_block} from './send_message_block';
import {brands_logo_block} from './brands_logo_block';
import {our_story_block} from './our_story_block';
import {who_is_hanan_faisal_block} from './who_is_hanan_faisal_block';
import {our_brands_block} from './our_brands_block';

export function indexBlocks() {
  headerBlock()
  hero_block()
  footerBlock()
  mission_block()
  vision_block()
  our_locations_block()
  about_us_block()
  contact_us_block()
  send_message_block()
  brands_logo_block()
  our_story_block()
  who_is_hanan_faisal_block()
  our_brands_block()
}

